module.exports = __webpack_public_path__ + "img/小兔子女孩.e8390048.png";